import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const accepted = localStorage.getItem("np-cookies");
      if (!accepted) setOpen(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem("np-cookies", "1");
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-50 max-w-md bg-white rounded-2xl shadow-2xl border border-blue-100 p-5">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="text-sm text-gray-700">
            Utilizamos cookies para ofrecerte la mejor experiencia. Puedes aprender más sobre qué cookies utilizamos o desactivarlas en los ajustes.
          </p>
          <div className="mt-3 flex gap-2">
            <button
              onClick={accept}
              className="px-4 py-2 rounded-lg bg-gradient-to-r from-[#1d6cb1] to-[#2a83ce] text-white text-sm font-semibold hover:shadow-lg transition"
            >
              Aceptar
            </button>
            <button
              onClick={() => setOpen(false)}
              className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition"
            >
              Ajustes
            </button>
          </div>
        </div>
        <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-600" aria-label="Cerrar">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
